import * as React from 'react';
import { Route, RouteComponentProps, RouteProps, Redirect } from 'react-router';
import { getGlobal } from 'reactn';
import { useSnackbar } from 'notistack';

const PrivateRoute: React.SFC<RouteProps & { authorizationNeeded: string[] }> = ({
    component: Component,
    authorizationNeeded,
    ...rest
}) => {
    const { enqueueSnackbar } = useSnackbar();

    if (!Component) {
        return null;
    }
    if (!getGlobal().keycloakState.isAuthorized(authorizationNeeded)) {
        enqueueSnackbar("You don't have permission to access ".concat(rest?.location?.pathname || '').concat('.'), {
            variant: 'error',
        });
    }
    return (
        <Route
            {...rest}
            render={(props: RouteComponentProps<{}>) =>
                getGlobal().keycloakState.isAuthorized(authorizationNeeded) ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                )
            }
        />
    );
};

export default PrivateRoute;
